module.exports = __webpack_public_path__ + "static/media/video_off.8ab1f7c6.svg";